import { Logger } from '~/helpers/logger';
import { Cart } from '~/modules/GraphQL/types';
import { VsfContext } from '~/composables/context';

export const removeCouponCommand = {
  execute: async (context: VsfContext, { currentCart, customQuery = { removeCouponFromCart: 'removeCouponFromCart' }, customHeaders = {} }) => {
    Logger.debug('[Magento]: Remove coupon from cart', { currentCart });

    const { data, errors } = await context.$magento.api.customMutation({mutation: customQuery.removeCouponFromCart, mutationVariables: {
      input: {cart_id: currentCart.id},
    }, customHeaders});

    Logger.debug('[Result]:', { data });

    return {
      // @ts-ignore
      updatedCart: { ...data.removeCouponFromCart?.cart, ...(currentCart.raw_id ? { raw_id: currentCart.raw_id } : {})} as unknown as Cart,
      updatedCoupon: { code: '' },
      errors,
    };
  },
};